'use strict';

var updateDate = require('./updateDate'),
    collectDateArguments = require('./collectDateArguments');

function advanceDateWithArgs(d, args, dir) {
  args = collectDateArguments(args, true);
  return updateDate(d, args[0], args[1], dir);
}

module.exports = advanceDateWithArgs;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/advanceDateWithArgs.js
// module id = 248
// module chunks = 0